import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { PbxWbAgentModel } from '../../../api/models/pbx-wb-agent-model';
import { DateTime } from 'luxon';
import { DurationPipe } from '../../../core/pipes/duration.pipe';
import { MatTooltip } from '@angular/material/tooltip';
import { PbxGroupModel } from '../../../api/models/pbx-group-model';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-agent-recover-time-component',
  template: `@if (isInRecovery) {
    <div class="agent-recover-time">
      <span [matTooltip]="infoMessage">
        <mat-icon>schedule</mat-icon>
      </span>
    </div>
  }`,
  styles: [
    `
      .agent-recover-time {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: #ff9800; /* Orange color for recovery */
      }
    `,
  ],
  standalone: true,
  imports: [MatTooltip, MatIcon],
})
export class AgentRecoverTimeComponent implements OnInit, OnDestroy {
  @Input() agentData: PbxWbAgentModel;
  @Input() queueData: PbxGroupModel;

  isInRecovery: boolean = false;
  infoMessage: string;
  totalTimeLeftInSeconds = 0;

  private timerSubscription: Subscription;
  private durationPipe = new DurationPipe();

  ngOnInit(): void {
    //console.log('AgentLoggedOutComponent initialized', this.agentData);
    this.updateRecoverTimeData();

    this.timerSubscription = interval(1000).subscribe(() => {
      this.updateRecoverTimeData();
    });
  }

  updateRecoverTimeData(): void {
    //console.log('Updating recovery time data', this.agentData, this.queueData);
    this.isInRecovery = false;
    this.infoMessage = '';
    this.totalTimeLeftInSeconds = 0;

    if (this.agentData) {
      const queueRecoveryTime = this.queueData?.recoverTime || 0;

      if (queueRecoveryTime > 0) {
        const lastAnsweredTime = DateTime.fromISO(this.agentData.lastAnsweredTime);
        const currentTime = DateTime.now();

        const diff = currentTime.diff(lastAnsweredTime, 'seconds').seconds;
        this.totalTimeLeftInSeconds = queueRecoveryTime - diff;

        if (this.totalTimeLeftInSeconds > 0) {
          this.isInRecovery = true;
          const timeLeftFormatted = this.durationPipe.transform(this.totalTimeLeftInSeconds * 1000, true);
          this.infoMessage = `In recovery. Time left: ${timeLeftFormatted}`;
        } else {
          this.totalTimeLeftInSeconds = 0;
          this.isInRecovery = false;
          this.infoMessage = `Agent has completed recovery.`;

          this.timerSubscription?.unsubscribe();
        }
      }
    }
  }

  ngOnDestroy(): void {
    //console.log('AgentLoggedOutComponent destroyed');
    this.timerSubscription?.unsubscribe();
  }
}
